import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-school-year.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParSchoolYearDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const parSchoolYearEntity = useAppSelector(state => state.parSchoolYear.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parSchoolYearDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.detail.title">ParSchoolYear</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parSchoolYearEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.code">Code</Translate>
            </span>
          </dt>
          <dd>{parSchoolYearEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.name">Name</Translate>
            </span>
          </dt>
          <dd>{parSchoolYearEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{parSchoolYearEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{parSchoolYearEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parSchoolYear.status">Status</Translate>
            </span>
          </dt>
          <dd>{parSchoolYearEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/par-school-year" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-school-year/${parSchoolYearEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParSchoolYearDetail;
